"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceSheetPartnerStatus = exports.PrincipalInvestmentStatus = void 0;
var PrincipalInvestmentStatus;
(function (PrincipalInvestmentStatus) {
    PrincipalInvestmentStatus["Claimed"] = "claimed";
    PrincipalInvestmentStatus["Term_sheet_signed"] = "term_sheet_signed";
    PrincipalInvestmentStatus["Closed"] = "closed";
    PrincipalInvestmentStatus["Success"] = "success";
    PrincipalInvestmentStatus["Failed"] = "failed";
})(PrincipalInvestmentStatus = exports.PrincipalInvestmentStatus || (exports.PrincipalInvestmentStatus = {}));
var BalanceSheetPartnerStatus;
(function (BalanceSheetPartnerStatus) {
    BalanceSheetPartnerStatus["Interested"] = "interested";
    BalanceSheetPartnerStatus["NotInterested"] = "not_interested";
})(BalanceSheetPartnerStatus = exports.BalanceSheetPartnerStatus || (exports.BalanceSheetPartnerStatus = {}));
//# sourceMappingURL=PrincipalInvestments.js.map